var building_amenities = require('./building_amenities')
var building_developers = require('./building_developers')
var building_restrictions = require('./building_restrictions')
var building_types = require('./building_types')
var countries = require('./countries')
var fee_frequencies = require('./fee_frequencies')
var fees = require('./fees')
var languages = require('./languages')
var lease_types = require('./lease_types')
var pet_breeds = require('./pet_breeds')
var pet_sizes = require('./pet_sizes')
var professions = require('./professions')
var relationships = require('./relationships')
var unit_features = require('./unit_features')
var unit_types = require('./unit_types')
var utilities = require('./utilities')
var financial_institutions = require('./financial_institutions')

var basicBootstrap = Object.assign(
  {},
  building_amenities,
  building_developers,
  building_restrictions,
  building_types,
  countries,
  fee_frequencies,
  fees,
  financial_institutions,
  languages,
  lease_types,
  pet_breeds,
  pet_sizes,
  professions,
  relationships,
  unit_features,
  unit_types,
  utilities
)

module.exports = basicBootstrap
